import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  Member: {
    id: 'studio.7L86Z5',
    defaultMessage: 'Member',
  },
  AppTranslator: {
    id: 'studio.Vg+/cC',
    defaultMessage: 'AppTranslator',
  },
  AppContentsExplorer: {
    id: 'studio.vUOBIG',
    defaultMessage: 'AppContentsExplorer',
  },
  AppContentsManager: {
    id: 'studio.ebfZw6',
    defaultMessage: 'AppContentsManager',
  },
  AppMemberManager: {
    id: 'studio.7IeO4D',
    defaultMessage: 'AppMemberManager',
  },
  AppGroupManager: {
    id: 'studio.2Ai+M8',
    defaultMessage: 'AppGroupManager',
  },
  AppGroupMembersManager: {
    id: 'studio.im867P',
    defaultMessage: 'AppGroupMembersManager',
  },
  AppManager: {
    id: 'studio.o61GlD',
    defaultMessage: 'AppManager',
  },
  AppCollectionManager: {
    id: 'studio.VDt0tf',
    defaultMessage: 'AppCollectionManager',
  },
  BlockManager: {
    id: 'studio.xfR9j2',
    defaultMessage: 'BlockManager',
  },
  Maintainer: {
    id: 'studio.eXDZGQ',
    defaultMessage: 'Maintainer',
  },
  Owner: {
    id: 'studio.zINlao',
    defaultMessage: 'Owner',
  },
  deleteMember: {
    id: 'studio.7EMBrV',
    defaultMessage: 'Delete member',
  },
  cancelLabel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  deleteConfirmationBody: {
    id: 'studio.RJTU10',
    defaultMessage: 'Are you sure you want to remove {member} from this organization?',
  },
  deleteSuccess: {
    id: 'studio.9laEii',
    defaultMessage: '{member} was successfully removed from the organization',
  },
  leaving: {
    id: 'studio.yA2xBS',
    defaultMessage: 'Leaving organization',
  },
  leaveConfirmationBody: {
    id: 'studio.91p+PL',
    defaultMessage: 'Are you sure you want to leave this organization?',
  },
  you: {
    id: 'studio.jSeYNv',
    defaultMessage: 'It’s you',
  },
  leave: {
    id: 'studio.fnihsY',
    defaultMessage: 'Leave',
  },
});
